import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'xpo-contextual-header',
  templateUrl: './contextual-header.component.html',
  styleUrls: ['./contextual-header.component.scss'],
  host: {
    class: 'xpo-ContextualHeader',
  },
  encapsulation: ViewEncapsulation.None,
})
export class ContextualHeaderComponent {}
